import { Lightbulb } from 'lucide-react';

interface Props {
  text: string;
  onClick: (text: string) => void;
  disabled?: boolean;
}

export default function FollowUpSuggestion({ text, onClick, disabled }: Props) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onClick(text)}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm border border-amber-200 bg-amber-50 text-amber-800 hover:bg-amber-100 hover:border-amber-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <Lightbulb className="w-3.5 h-3.5" />
      {text}
    </button>
  );
}
